// Configuration des VRAIS numéros SAVEA avec formats spécifiques
export const SAVEA_PHONE_CONFIG = {
  // FRANCE - Format code: 0033XXXXXXXXX, Affichage: 0X XX XX XX XX
  FR: {
    electricity: {
      LP: '0033970252402', // Pages fournisseurs + homepage France énergie
      SB: '0033564098904'  // Sticky bar pages fournisseurs France énergie
    },
    internet: {
      LP: '0033564098903', // Pages fournisseurs + homepage France internet  
      SB: '0033484310500'  // Sticky bar pages fournisseurs France internet
    }
  },
  
  // ESPAGNE - Format code: 0034XXXXXXXXX, Affichage: XXX XXX XXX
  ES: {
    electricity: {
      LP: '0034932201179', // Pages fournisseurs + homepage Espagne énergie
      SB: '0034932201182'  // Sticky bar pages fournisseurs Espagne énergie
    },
    internet: {
      LP: '0034954057282', // Pages fournisseurs + homepage Espagne internet
      SB: '0034954057287'  // Sticky bar pages fournisseurs Espagne internet
    }
  }
};

// Fonction pour formater numéro français (0X XX XX XX XX)
const formatFrenchNumber = (fullNumber) => {
  const digits = fullNumber.substring(4); // Enlever 0033
  return `0${digits.substring(0,1)} ${digits.substring(1,3)} ${digits.substring(3,5)} ${digits.substring(5,7)} ${digits.substring(7,9)}`;
};

// Fonction pour formater numéro espagnol (XXX XXX XXX) 
const formatSpanishNumber = (fullNumber) => {
  const digits = fullNumber.substring(4); // Enlever 0034
  return `${digits.substring(0,3)} ${digits.substring(3,6)} ${digits.substring(6,9)}`;
};

// Fonction pour récupérer numéro SAVEA formaté pour affichage CTA
export const getSaveaPhone = (country, vertical, type = 'LP') => {
  const fullNumber = SAVEA_PHONE_CONFIG[country]?.[vertical]?.[type];
  if (!fullNumber) return '09 77 42 24 24'; // Fallback
  
  if (country === 'FR') {
    return formatFrenchNumber(fullNumber);
  } else if (country === 'ES') {
    return formatSpanishNumber(fullNumber);
  }
  return fullNumber;
};

// Fonction pour récupérer numéro SAVEA complet pour tel: links (SANS +)
export const getSaveaPhoneTel = (country, vertical, type = 'LP') => {
  const fullNumber = SAVEA_PHONE_CONFIG[country]?.[vertical]?.[type];
  return fullNumber || '0033177422424'; // SANS le + pour les liens tel:
};

// Messages spécialistes par vertical (inchangé)
export const SPECIALIST_MESSAGES = {
  FR: {
    electricity: {
      title: "Spécialiste Énergie",
      description: "Expert en contrats d'électricité et comparaison d'offres énergétiques",
      cta: "Parler à un Spécialiste",
      help: "Nous vous aidons à comparer les offres avec d'autres fournisseurs"
    },
    internet: {
      title: "Spécialiste Internet", 
      description: "Expert en offres internet et négociation avec fournisseurs",
      cta: "Parler à un Spécialiste",
      help: "Nous vous aidons à trouver l'offre internet idéale"
    }
  },
  ES: {
    electricity: {
      title: "Especialista Energía",
      description: "Experto en contratos de electricidad y comparación de ofertas energéticas", 
      cta: "Hablar con Especialista",
      help: "Te ayudamos a comparar las ofertas con otros proveedores"
    },
    internet: {
      title: "Especialista Internet",
      description: "Experto en ofertas internet y negociación con proveedores",
      cta: "Hablar con Especialista", 
      help: "Te ayudamos a encontrar la oferta internet ideal"
    }
  }
};

export const getSpecialistMessage = (country, vertical) => {
  return SPECIALIST_MESSAGES[country]?.[vertical] || SPECIALIST_MESSAGES.FR.electricity;
};

// Fonction pour mettre à jour facilement les numéros (pour vous)
export const updateSaveaPhones = (newPhoneConfig) => {
  // Cette fonction permettra de mettre à jour les numéros facilement
  Object.assign(SAVEA_PHONE_CONFIG, newPhoneConfig);
  console.log('SAVEA phone numbers updated:', SAVEA_PHONE_CONFIG);
};